import events from "~/mixins/events"

import input_text from "~/components/inputs/text"
import modal_footer from "~/components/shared/modal/footer"

export default {
  mixins: [events],
  components: { input_text, modal_footer },
  data: function () {
    return {
      name: "",
      loading: false,
    }
  },
  computed: {
    servedInfs: function () {
      if (typeof this.influencers === "number") return [this.influencers]
      else if (typeof this.influencers === "object") return this.influencers
      else return []
    },
  },
  methods: {
    close: function () {
      this.$parent.$emit("close")
    },
    cancel: function () {
      this.$emit("cancel")
    },
    createBucket: function () {
      this.loading = true
      this.$axios
        .$post(
          "/agency/favorites/",
          {
            influencers: this.servedInfs,
            name: !this.name.length ? "Default" : this.name,
            agency: this.$store.state.user.agency.id,
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .then((resp) => {
          this.loading = false
          this.trackEvent({
            category: "Bucket Management",
            action: "Create new bucket",
          })
          this.$store.commit("user/favorites/ADD_BUCKETS", [resp])
          this.$emit("cancel", resp)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
  props: {
    influencers: {
      type: [Number, Array],
      required: false,
    },
    has_cancel: {
      type: Boolean,
      default: function () {
        return false
      },
    },
  },
}
